import React, { useRef, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { Form, Formik } from 'formik';
import InputField from '../../components/inputFields/InputField';
import Button from '../../components/buttons/Button';
import { useNavigate } from 'react-router-dom';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import ReceiptComponent from '../../components/RecepitComponent';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { toast } from 'react-toastify';
import { getUserName } from '../../utils/localStoarege';
import { convertAmountToWords } from '../../utils/ConvertToWords';
import { addNewConsultationInvoices } from '../../services/clinic/consultation';

function AddConsultationInvoice() {
    const navigate = useNavigate();
    const receiptRef = useRef();
    const [isPdfVisible, setPdfVisible] = useState(false);

    const handleFormSubmit = async (values, { setSubmitting }) => {
        try {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("mobile_number", values.phone);
            formData.append("machine_name", getUserName());
            formData.append("amount", values.amount);
            formData.append("mode", values.mode);
            formData.append("transaction_no", values.transaction_number);
            const response = await addNewConsultationInvoices(formData);

            if (response?.status === 201) {
                toast.success("Consultation Added successfully!");
                setPdfVisible(true);
                setTimeout(() => {
                    downloadPdf(values);
                    navigate(-1);
                }, 1000);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    const downloadPdf = async (values) => {
        const element = receiptRef.current;

        // Use html2canvas to capture the component
        const canvas = await html2canvas(element, { scale: 2 }); // Higher scale for better quality
        const imgData = canvas.toDataURL('image/png'); // Convert canvas to image data

        // Create a PDF using jsPDF
        const pdf = new jsPDF('p', 'mm', 'a5');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(values.name);
        setTimeout(() => {
            setPdfVisible(false);
        }, 1000);
    };

    const handleDiscardChanges = (resetForm) => {
        resetForm(); // Reset the form
        navigate("/consultation-invoice"); // Redirect to invoice page
    };

    return (
        <>
            <Breadcrumbs items={[
                { name: 'Home', link: '/invoice' },
                { name: 'Consultation', link: '/consultation-invoice' },
                { name: 'Add Invoice' },
            ]} />
            <div className="mt-8">
                <Formik
                    initialValues={{
                        name: "",
                        phone: "",
                        amount: "",
                        mode: "UPI",
                    }}
                    validationSchema={Yup.object({
                        name: Yup.string().required("Please enter a name"),
                        phone: Yup.string().required("Please enter a phone number").min(10),
                        amount: Yup.number().required("Please enter an amount"),
                        mode: Yup.string().required("Please select a payment mode"),
                    })}
                    onSubmit={handleFormSubmit}
                >
                    {({ isSubmitting, setFieldValue, resetForm, values }) => (
                        <Form onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                            }
                        }}>
                            <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                                <div className="flex flex-col w-full">
                                    <InputField
                                        label="Name"
                                        name="name"
                                        type="text"
                                        placeholder="Enter Name"
                                        required
                                    />
                                    <InputField
                                        label="Contact"
                                        name="phone"
                                        type="text"
                                        placeholder="Enter Contact Number"
                                        required
                                    />
                                    <InputField
                                        label="Amount"
                                        name="amount"
                                        type="text"
                                        placeholder="Enter Amount"
                                        required
                                    />
                                    <FormikDropdown
                                        label="Mode"
                                        name="mode"
                                        placeholder="Select Mode"
                                        required={true}
                                        options={[
                                            { label: "NEFT", value: "NEFT" },
                                            { label: "Cash", value: "Cash" },
                                            { label: "UPI", value: "UPI" },
                                            { label: "Card", value: "Card" },
                                        ]}
                                    />
                                    {
                                        values.mode === "UPI" || values.mode === "Card" ?
                                            <InputField
                                                label={values.mode === "UPI" ? "UPI Number" : "Card Number"}
                                                name="transaction_number"
                                                placeholder={values.mode === "UPI" ? "Enter UPI Number" : "Enter Card Number"}
                                            /> : <></>
                                    }
                                    <div className="py-5 flex justify-end gap-6">
                                        <div>
                                            <Button
                                                type="button"
                                                className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                                onClick={() => handleDiscardChanges(resetForm)}
                                                disabled={isSubmitting}
                                            >
                                                Discard Changes
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                type="submit"
                                                className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? "Saving..." : "Save"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                {/* Receipt Preview */}
                                <div className="flex flex-col justify-start w-full my-2">
                                    <span className="mb-2">
                                        <StyledHeadingText text={"Preview"} />
                                    </span>
                                    <div ref={receiptRef} className={isPdfVisible ? "" : "hidden"}>
                                        <ReceiptComponent
                                            isConsultance={true}
                                            name={values.name || "N/A"}
                                            amount={values.amount || 0}
                                            paymentMode={values.mode || "N/A"}
                                            receiptNo={Math.floor(Math.random() * 10000)}
                                            phone={values.phone || "N/A"}
                                            packageType={values.package_type}
                                            amountInWords={
                                                values.amount
                                                    ? `${convertAmountToWords(values.amount)}`
                                                    : "Zero Only"
                                            }
                                            transactionNumber={values.transaction_number}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
}

export default AddConsultationInvoice;
